/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsDeploymentStateEnum } from './vcdsDeploymentStateEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface VcdsDeploymentHead { 
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    state?: VcdsDeploymentStateEnum;
    /**
     * Deployment name
     */
    name?: string;
    /**
     * Deployment secondary name
     */
    secondary_name?: string;
    vmware_managed?: boolean;
    discovered?: boolean;
    login_allowed?: boolean;
}
export namespace VcdsDeploymentHead {
}


